import { render, staticRenderFns } from "./WillbeneficairiesFinancialVulnerableDetails.vue?vue&type=template&id=35568e12"
import script from "./WillbeneficairiesFinancialVulnerableDetails.vue?vue&type=script&lang=js"
export * from "./WillbeneficairiesFinancialVulnerableDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports